import React, { useEffect, useState } from 'react';
import ConoceMas from './pages/conoceMas';
import { Banner } from './components/Banner';
import { Footer } from './components/Footer';
import { ReworthDirectory } from '@reworthrewards/directory-react-component';
import { useDirectoryConfig } from './hooks/useDirectoryConfig';
import TagManager from "react-gtm-module";

const App = () => {
  const ruta = window.location.pathname;
  const { lat, lng, isLoading, isProd } = useDirectoryConfig();
		if (process.env.REACT_APP_STAGE == "prod") {
			TagManager.initialize({
				gtmId: isProd ? "GTM-T4D926Z" : "GTM-M3H4324",
				dataLayerName: "DataLayer",
			});
		}
		
	const fiid = process.env.REACT_APP_FIID;
	
	const directoryProps = {
		accentColor: "#E10098",
		lang: "ES",
		env: process.env.REACT_APP_STAGE,
		fiid,
		gtm: true,
		skin:'LIVERPOOL',
		fontFamily:'Ambit',
		...(lat && lng && { geo: `${lat},${lng}` }),
	};

  return (
    <>
      <Banner />
      <ReworthDirectory
        {...directoryProps}
      />
      <Footer />
    </>
  )
}



export default App;

